import React from 'react'
import Box from '@mui/material/Box'
import { PURPOSE_DATA_ROLE_NAMES, PurposeDataRole } from 'interfaces/purposes/purposeDataRole'
import { PURPOSE_DATA_USAGE_DURATION_UNIT_NAMES } from 'interfaces/purposes/dataUsageDuration'
import { Chip, ContentGroup, InfoRow } from '@ketch-com/deck'
import { Typography } from '@mui/material'
import { NavigationBreadCrumbs } from 'components/appLayout/appNavigation/breadcrumbs/NavigationBreadCrumbs'
import { RoutesManager } from 'utils/routing/routesManager'
import { EmptyValueRenderer } from 'components/EmptyValueRenderer'
import { usePurposeViewContext } from 'pages/policyCenter/purposes/view/context/PurposeViewContext'

export const PurposesTabOverview: React.FC = () => {
  const { purpose } = usePurposeViewContext()
  return (
    <Box display="flex" flexDirection="column" gap={4}>
      <NavigationBreadCrumbs
        type="dark"
        items={[
          { title: 'Privacy Program', link: RoutesManager.policyCenter.root.getURL() },
          { title: 'Purposes', link: RoutesManager.policyCenter.purposes.root.getURL() },
          {
            title: purpose?.name || purpose?.code,
            link: RoutesManager.policyCenter.purposes.view.root.getURL({ code: purpose?.code || '' }),
          },
          { title: 'Overview' },
        ]}
      />

      <ContentGroup title="Basic Details" titleVariant="h3" variant="inner-page-header" />
      <InfoRow title="Description">
        {purpose?.description ? (
          <Typography
            sx={{ whiteSpaceCollapse: 'break-spaces' }} /*added whiteSpaceCollapse style to fix bug KD-12825*/
          >
            {purpose?.description}
          </Typography>
        ) : (
          <EmptyValueRenderer />
        )}
      </InfoRow>
      <InfoRow title="Ketch Purpose">
        <Box display="flex" gap={1} flexWrap="wrap">
          {!!purpose?.canonicalPurposes?.length ? (
            purpose?.canonicalPurposes?.map(canonicalPurpose => {
              return <Chip key={canonicalPurpose?.code} label={canonicalPurpose?.name} />
            })
          ) : (
            <EmptyValueRenderer />
          )}
        </Box>
      </InfoRow>
      <InfoRow title="Subject Type">
        <Box display="flex" gap={1} flexWrap="wrap">
          {!!purpose?.dataSubjectTypes?.length ? (
            purpose?.dataSubjectTypes?.map(dst => {
              return <Chip label={dst.name} secondaryLabel={dst.code} />
            })
          ) : (
            <Typography color="lightGrey.main">None</Typography>
          )}
        </Box>
      </InfoRow>
      <InfoRow title="Organization's Data Role">
        {PURPOSE_DATA_ROLE_NAMES?.[purpose?.dataRole || PurposeDataRole.CONTROLLER] || (
          <Typography color="lightGrey.main">None</Typography>
        )}
      </InfoRow>
      <InfoRow title="Duration of Data Usage" mb={4}>
        {purpose?.dataUsageDuration && purpose?.dataUsageDurationUnit !== undefined
          ? `${purpose.dataUsageDuration} ${PURPOSE_DATA_USAGE_DURATION_UNIT_NAMES[purpose.dataUsageDurationUnit]}`
          : undefined}
      </InfoRow>
    </Box>
  )
}
